function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 1a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM11 2.5a2.5 2.5 0 11.603 1.628l-6.718 3.12a2.499 2.499 0 010 1.504l6.718 3.12a2.5 2.5 0 11-.488.876l-6.718-3.12a2.5 2.5 0 110-3.256l6.718-3.12A2.5 2.5 0 0111 2.5zm-8.5 4a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm11 5.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
});

function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "share_svg__b-icon share_svg__bi share_svg__bi-share share_svg__ml-1",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    "aria-label": "share",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _ref);
}

export default SvgShare;